<template>
  <div :class="name">
    <card-select :value="1" :data="cardSelectData" />
    <div>
      <div :class="`${name}__header`">
        <i class="vi-icon2-arrowdown" />
        <div :class="`${name}__title`">{{ $t('module_selected_product_title') }}</div>
        <vi-button type="text" icon="vi-icon2-edit" :class="`${name}__edit`" />
      </div>
      <skeleton-basic width="48px" height="48px" style="margin: 0 0 0 48px" />
    </div>
    <div>
      <div :class="`${name}__header`">
        <i class="vi-icon2-arrowdown" />
        <div :class="`${name}__title`">{{ $t('module_selected_creative_title') }}</div>
        <vi-button type="text" icon="vi-icon2-edit" :class="`${name}__edit`" />
      </div>
      <skeleton-basic width="48px" height="48px" style="margin: 0 0 0 48px" />
    </div>
    <div>
      <div :class="`${name}__header`">
        <i class="vi-icon2-arrowdown" />
        <div :class="`${name}__title`">{{ $t('module_selected_identity_title') }}</div>
      </div>

      <div :class="`${name}__content`">
        <skeleton-basic :class="`${name}__content__connected-avatar`" />

        <div :class="`${name}__content__connected-content`">
          <div :class="`${name}__content__connected-title`">
            <skeleton-basic :class="`${name}__content__connected-name`" />
          </div>
          <skeleton-basic :class="`${name}__content__connected-id`" />
        </div>
      </div>
    </div>
    <div>
      <div :class="`${name}__subFormTitle`">
        <!-- 标题文案 -->
        <span>{{ $t('module_attachment_creative_form_title') }}</span>
        <span :class="`${name}__subFormTitle__titleSub`"
          >&nbsp;{{ $t('module_attachment_creative_form_title_sub') }}</span
        >
      </div>

      <skeleton-basic width="183px" height="96px" style="margin: 0 0 0 16px" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import SkeletonBasic from '@/components/skeleton/basic.vue';
import CardSelect from '@/components/common/card-select/index.vue';
import { i18n } from '@/i18n';

const name = 'ttam-affiliate-ad-skeleton';
export default defineComponent({
  name,
  components: {
    SkeletonBasic,
    CardSelect,
  },
  setup() {
    const cardSelectData = [
      {
        id: 1,
        title: i18n.t('module_affiliate_start_with_product_title'),
        desc: i18n.t('module_affiliate_start_with_product_desc'),
      },
    ];

    return {
      name,
      cardSelectData,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-affiliate-ad-skeleton';
.#{$name} {
  .ttam-card-select.assist .vi-col {
    max-width: 100%;
    width: 100%;
  }
  .vi-button--text {
    color: $--color-neutral-grey-0;
  }
  .vi-button--text.is-disabled {
    color: $color-text-disabled;
  }

  &__header {
    display: flex;
    align-items: center;
    position: relative;

    padding: 12px 0 16px 18px;
    margin-top: 24px;
    border-top: 1px solid #f6f6f6;

    :global {
      .vi-icon2-arrowdown {
        color: #8a8a8a;
      }
    }
  }

  &__title {
    margin-left: 16px;
    color: #121212;
    font-weight: 500;
    line-height: 22px;
  }

  &__edit {
    position: absolute;
    right: 0;
  }

  &__content {
    padding-left: 30px;
    display: flex;

    &__connected {
      &-avatar {
        width: 40px;
        height: 40px;
        margin-right: 12px;
        border-radius: 50%;
        flex-shrink: 0;
      }

      &-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        overflow: hidden;
        line-height: 20px;
      }

      &-title {
        @include flex-center(start);
        width: 100%;
      }

      &-name {
        margin-bottom: 6px;
        width: 154px;
        height: 22px;
      }

      &-id {
        margin-right: 8px;
        width: 124px;
        height: 14px;
      }
    }
  }

  &__subFormTitle {
    font-weight: $font-weight-bold;
    margin: 36px 0 8px 16px;
    color: $color-black-1;
    font-size: 14px;
    line-height: 22px;

    &__titleSub {
      line-height: 22px;
      color: #8a8a8a;
    }
  }
}
</style>
